import React from 'react';
// import { useHistory } from 'react-router';
import LazyLoad from 'react-lazyload';
import Sponsors from '../Sponsors/Sponsors';
import About from '../About/About';
import CountDown from '../../components/Countdown/CountDown';
import SpeakersContainer from '../Speakers/Speakers';
// import Hosts from '../Hosts/Hosts';
// import Patronage from '../Patronage/Patronage';
import './Home.scss';
import PrivacySection from '../PrivacySection/PrivacySection';
import { FIRST_DAY, LAST_DAY, YEAR, SHORT_YEAR } from '../../constants';

const Home = () => {
  // const history = useHistory();

  return (
    <div id="home-section">
      <LazyLoad height={window.height}>
        <video
          autoPlay
          className="lazy"
          height={window.height}
          id="home-animation"
          loop
          muted
          playsInline
          width={window.width}
          //
        >
          <source src="imgs/OpenSlava_Banner_Animated_2med.webm" type="video/webm" />
          <source src="imgs/OpenSlava_Banner_Animated_5sm.mp4" type="video/mp4" />
        </video>
      </LazyLoad>
      <div className="container">
        <div className="home">
          <div />
          <div className="home-middle">
            <div className="home-middle-first-row" />
            <div className="home-middle-second-row light-helo">
              <div className="logo">
                <div>
                  <span className="bold-text">OPEN</span>
                  <span className="light-text">SLAVA</span>
                  <span className="bold-text">{SHORT_YEAR}</span>
                </div>
              </div>
              <div className="logo-subtitle">
                <div>Limitless possibilities with technology reinvention</div>
              </div>
            </div>
            <div className="home-middle-third-row">
              <div className="logo-button">
                {/* <a
                  className="button button-light"
                  href={cventRegistration}
                  id="cfs-button"
                  rel="noopener noreferrer"
                  target="_blank">
                  REGISTER NOW */}
                {/* JOIN THE WAITINGLIST */}
                {/* </a> */}
                {/* <button //  TO DO BROKEN ON WIDE SCREEN
                  className="button"
                  id="cfs-button"
                  onClick={() => history.push('/livestream')}
                  type="button">
                  Livestream
                </button>
                <button
                  className="button"
                  id="cfs-button"
                  onClick={() => history.push('/ff')}
                  type="button">
                  Feedback Form
                </button> */}
                {/* <a
                  className="button"
                  href="https://photos.app.goo.gl/aXPyxPstRG49pbXG8"
                  id="cfs-button"
                  rel="noopener noreferrer"
                  target="_blank">
                  PHOTOS
                </a>
                <button
                  className="button"
                  id="cfs-button"
                  onClick={() => history.push('/program')}
                  type="button">
                  RECORDINGS
                </button> */}
              </div>
            </div>
            <div className="home-middle-fourth-row dark-helo">
              <div className="home-bottom-left">
                <span>ACCENTURE CONFERENCE ON</span>
                <span>EMERGING TECHNOLOGIES</span>
                <span>AND OPEN SOURCE</span>
              </div>
              <div className="home-bottom-right">
                <span>
                  October {FIRST_DAY}-{LAST_DAY}, {YEAR}
                </span>
                <span>FEI STU, ILKOVICOVA 3</span>
                <span>BRATISLAVA, SLOVAKIA</span>
              </div>
            </div>
            {/* <div className="home-middle-third-row"> */}
            <CountDown
              afterDateMessage=""
              givenDate={new Date(`Oct ${FIRST_DAY} ${YEAR} 8:30:00`)}
              title=""
            />
            {/* </div> */}
          </div>
        </div>
      </div>
      <></>
      {/* <Patronage /> */}
      <About />
      {/* <Hosts /> */}
      <SpeakersContainer />
      <Sponsors />
      <PrivacySection />
    </div>
  );
};

export default Home;
